export enum NotificationLevel {
    INFO = 'info',
    ATTENTION = 'attention',
    WARNING = 'warning',
    WARNING_ANSI = 'warning-ansi',
    ERROR = 'error',
    VALID = 'valid',
}

export enum NotificationSize {
    XS = 'xs',
    S = 's',
    M = 'm',
    L = 'l',
}

export type TranslationWithParams = { key: string; params: { [key: string]: string } };
